/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 29.06.2016
 *
 */
'use strict';

import React from 'external/react';

import { UserHistoryEntry } from 'plugin/user-state-history-portlet';
import { Icon, MiniWidgetLineWrapper } from 'plugin/base-portlet';
import { Button } from 'external/react-bootstrap';

import StateValueLabel from '../components/StateValueLabel';

// eslint-disable-next-line react/prop-types
const MiniWidgetStatusLine = ({ status, iconClass, onClick, fastEditFunc }) => {

  const _onClickEditIcon = (e) => {
    e.stopPropagation();
    fastEditFunc();
  };

    return (
        <MiniWidgetLineWrapper onClick={onClick} className="status-line w-100">
            <div className="edit-button-wrapper">
                {
                    iconClass && <Icon name={iconClass}/>
                }
                <StateValueLabel item={status}/>
                {
                fastEditFunc &&

                    <Button
                        variant="outline-primary"
                        title="Bearbeiten"
                        className="mini-widget-edit-button"
                        onClick={_onClickEditIcon}
                    >
                        <Icon name="pencil" className="mini-widget-edit-icon" title="Bearbeiten"/>
                    </Button>
            }
            </div>

      <UserHistoryEntry
        userMeta={status.userMeta}
        timestamp={status.timestamp}
      />

    </MiniWidgetLineWrapper>
  );
};
export default MiniWidgetStatusLine;



// WEBPACK FOOTER //
// ./js/components/MiniWidgetStatusLine.jsx